<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <bridge-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></bridge-add-form>
                <bridge-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></bridge-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import BridgeAddForm from './forms/add/representations/WizardForm'
    import BridgeUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../bridgeStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            BridgeAddForm,
            BridgeUpdateForm
        },

    }
</script>
